<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            <v-tabs grow>
              <v-tabs-slider color="green" />

              <v-tab @click="reportMode = 'ignore'">Игноры</v-tab>
              <v-tab @click="reportMode = 'hold'">Удержания</v-tab>
              <v-tab @click="reportMode = 'drop'">Сбросы</v-tab>
            </v-tabs>

          </v-card-title>
          <v-card-title v-if="reportMode === 'ignore'" class="mb-n4">Игноры</v-card-title>
          <v-card-title v-else-if="reportMode === 'hold'" class="mb-n4">Удержания</v-card-title>
          <v-card-title v-else-if="reportMode === 'drop'" class="mb-n4">Сбросы</v-card-title>
          <!-- Селекторы -->
          <v-form ref="form" class="mb-n1">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4">
                  <date-time-picker v-model="date" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <GroupSelector noRules v-model="groups" @change:users="fillAgents" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <UserSelector v-model="agents" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <ProjectSelector v-model="projects" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <custom-select
                    label="Смены"
                    v-model="shifts"
                    :items="shiftsOptions"
                    multiple
                  />
                </v-col>

                <v-col v-if="reportMode === 'ignore'" cols="12" sm="6" md="4" lg="4">
                  <v-checkbox
                    v-model="only_abandon"
                    hide-details
                    label="Только пропущенные"
                  ></v-checkbox>
                </v-col>

                <v-col align="right">
                  <v-btn
                    color="success"
                    @click="loadReport"
                  >
                    Поиск
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <IgnoreReport v-if="reportMode === 'ignore'" :report="ignoreReport" />
    <HoldReport v-else-if="reportMode === 'hold'" :report="holdReport" />
    <DropReport v-else-if="reportMode === 'drop'" :report="dropReport" />

  </v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import UserSelector from '~/components/partials/selectors/UserSelector.vue';
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue';
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';
import IgnoreReport from './IgnoreReport.vue';
import HoldReport from './HoldReport.vue';
import DropReport from './DropReport.vue';


export default {
  name: 'OperatorsIgnore',
  components: {
    UserSelector,
    GroupSelector,
    ProjectSelector,
    IgnoreReport,
    HoldReport,
    DropReport,
  },
  data() {
    return {
      reportMode: 'ignore', // 'ignore' | 'hold' | 'drop'
      ignoreReport: [],
      holdReport: [],
      dropReport: [],
      date: {},
      agents: [],
      projects: [],
      groups: [],
      shifts: [],
      shiftsOptions: [],
      only_abandon: false,
    }
  },

  computed: {
    ...mapGetters({
      loading: "shared/getLoading",
      report: "operators/report",
    }),

    payload() {
      const res = {
        period: [
          moment(this.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.date.end).format('YYYY-MM-DD HH:mm:ss'),
        ],
        users: this.agents,
        projects: this.projects,
        only_abandon: this.only_abandon,
      }

      if (this.shifts.length > 0) res.shifts = this.shifts

      return res
    }
  },

  watch: {
    groups(curr) {
      if (curr.length > 3) curr.pop()
    },
  },

  methods: {
    ...mapActions({
      loadIgnoreReport: 'operators/loadIgnoreReport',
      loadHoldReport: 'operators/loadHoldReport',
      loadDropReport: 'operators/loadDropReport',
      getShifts: 'shared/getShifts',
      resetAllState: 'resetAllState',
    }),

    fillAgents(operators) {
      this.agents = operators;
    },

    setAgents() {
      if (this.groups.length > 3) return
      // Добавляем ID операторов из выбранных групп в agents
      let operatorsFromGrp = [];
      this.groups.forEach((el) => {
        let tmpGrp = this.groupsGetter.find((group) => group.id === el);
        operatorsFromGrp.push(tmpGrp);
      });
      operatorsFromGrp = operatorsFromGrp.map((el) => el.members_ids).flat();
      operatorsFromGrp = [...new Set(operatorsFromGrp)];

      let res = this.agentsGetter.filter(agent => {
        return operatorsFromGrp.includes(agent.id)
      })
      res = res.map(agent => agent.sip_number);

      this.agents = res;
    },

    async loadReport() {
      
      if (this.reportMode === 'ignore') {
        this.ignoreReport = []
        this.ignoreReport = await this.loadIgnoreReport(this.payload)
      } else if (this.reportMode === 'hold') {
        this.holdReport = []
        this.holdReport = await this.loadHoldReport(this.payload)
      } else if (this.reportMode === 'drop') {
        this.dropReport = []
        this.dropReport = await this.loadDropReport(this.payload)
      }
    },
  },

  async mounted() {
    this.shiftsOptions = await this.getShifts()

    if (this.$route.query['project']) {
      this.projects.push(+this.$route.query['project']);
      if (this.$route.query['period[start]'] && this.$route.query['period[end]']) {
        this.date.start = new Date(this.$route.query['period[start]'])
        this.date.end = new Date(this.$route.query['period[end]'])
      }
      this.loadReport();
    }

  },

  beforeDestroy() {
    this.resetAllState();
  },
};
</script>

<style>
</style>